<template>
    <div>
        <v-container>
            <v-row>
                <v-col>
                    <h1 class="text-left">We are the solving Problem</h1>
                    <v-container style="padding-top:25px;">
                        <v-row justify="center">
                            <v-col class="col-content" md="3">
                                <v-card
                                    class="mx-auto"
                                    max-width="344"
                                >
                                    <v-card-text>
                                        <div class="title--primary text-left">
                                            ACCESS DIFFICULTIES (LICENSE)
                                        </div>
                                        <div class="text--primary text-left">
                                            Ease for partners in opening access to market investment products on partner platforms, both from licensing and legality following applicable regulations.
                                        </div>
                                        <div class="image--primary">
                                            <v-img src="https://assets.invisee.com/statis/revamp/solve/license.png" max-height="103px" max-width="74px" class="mx-auto"></v-img>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col class="col-content" md="3">
                                <v-card
                                    class="mx-auto"
                                    max-width="344"
                                >
                                    <v-card-text>
                                        <div class="title--primary text-left">
                                            BRAND DISTRUST
                                        </div>
                                        <div class="text--primary text-left">
                                            <br>Potential cooperation in marketing investment products from the best and bona fide provider products, including the largest investment Manager company in Indonesia.<br><br>
                                        </div>
                                        <div class="image--primary">
                                            <v-img src="https://assets.invisee.com/statis/revamp/solve/brand.png" max-height="78px" max-width="115px" class="mx-auto"></v-img>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col class="col-content" md="3">
                                <v-card
                                    class="mx-auto"
                                    max-width="344"
                                >
                                    <v-card-text>
                                        <div class="title--primary text-left">
                                            PAINFUL INTEGRATION PROCESS
                                        </div>
                                        <div class="text--primary text-left">
                                            Ease of system integration with achoice of integration methods that suit partner needs.<br><br><br>
                                        </div>
                                        <div class="image--primary">
                                            <v-img src="https://assets.invisee.com/statis/revamp/solve/integration.png" max-height="99px" max-width="102px" class="mx-auto"></v-img>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col class="col-content" md="3">
                                <v-card
                                    class="mx-auto"
                                    max-width="344"
                                >
                                    <v-card-text>
                                        <div class="title--primary text-left">
                                            HIGHLY COST FOR PROVIDING PRODUCT
                                        </div>
                                        <div class="text--primary text-left">
                                            Minimize the cost of providing investment product.<br><br><br><br><br>
                                        </div>
                                        <div class="image--primary">
                                            <v-img src="https://assets.invisee.com/statis/revamp/solve/providing.png" max-height="78px" max-width="118px" class="mx-auto"></v-img>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                
            }
        },
    }
</script>

<style scoped>
    .title--primary{
        color: #0261d8;
        font-weight: bold;
        font-size: 20px;
    }
    .text--primary{
        padding: 20px 0;
    }
</style>